<template>
  <div class="card_box" style="margin-top:20px;">
    <Card>
      <div slot="title" class="titlebox">
        <span class="title">{{$t('label.Inquiry.InquiryFor')}}</span>
        <Icon type="ios-create-outline" class="applyicon" />
      </div>
      <!-- 主表 -->
      <Form ref="formdata" :model="formdata" :rules="this.rule">
        <!-- 主表表单 -->
        <table class="form-table form-table-print">
          <tbody>
            <tr>
              <!-- 询价编号 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.InquiryNo')}}</span>
              </th>
              <td>
                <Form-item prop="inquiryId">
                  <Input type="text" v-model="formdata.inquiryId" disabled />
                </Form-item>
              </td>
              <!-- 申请人 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.Applicants')}}</span>
              </th>
              <td>
                <Form-item prop="applicantUserId">
                  <Input type="text" v-model="sqr" disabled />
                </Form-item>
              </td>
              <!-- 申请日期 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.ApplicationDate')}}</span>
              </th>
              <td>
                <Form-item prop="applyDate">
                  <ab-date
                    disabled
                    style="width:100%;"
                    v-model="formdata.applyDate"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
            </tr>
            <!-- 新加功能 公司-据点选择 -->
            <tr>
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryCompany') }}</span>
              </th>
              <td>
                <Form-item prop="applyCompanyId" style="text-align:left;" v-if="permission.xjsq.applyCompanyId==='w'">
                  <Select
                    v-model="formdata.applyCompanyId"
                    :disabled="permission.xjsq.applyCompanyId!=='w'"
                  >
                    <Option
                      v-for="item in companys"
                      :value="item.key"
                      :key="item.key"
                    >{{ item.name }}</Option>
                  </Select>
                </Form-item>
                <Form-item prop="applyCompanyName" v-if="permission.xjsq.applyCompanyId!=='w'">
                  <Input type="text" v-model="formdata.applyCompanyName" disabled />
                </Form-item>
              </td>
              <!-- 据点 -->
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryStronghoId') }}</span>
              </th>
              <td>
                <Form-item prop="applyStrongholdId" style="text-align:left;" v-if="permission.xjsq.applyStrongholdId==='w'">
                  <Select
                    v-model="formdata.applyStrongholdId"
                    :disabled="permission.xjsq.applyStrongholdId!=='w'"
                    @on-change="getDepartment()"
                  >
                    <Option
                      v-for="item in strongholds"
                      :value="item.key"
                      :key="item.key"
                    >{{ item.name }}</Option>
                  </Select>
                </Form-item>
                <Form-item prop="applyStrongholdName" v-if="permission.xjsq.applyStrongholdId!=='w'">
                  <Input type="text" v-model="formdata.applyStrongholdName" disabled />
                </Form-item>
              </td>
              <!-- 申请部门 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.ApplyDepartment')}}</span>
              </th>
              <td>
                <Form-item prop="applyDepartmentId" style="text-align:left;" v-if="permission.xjsq.applyDepartmentId==='w'">
                  <Select
                    v-model="formdata.applyDepartmentId"
                    :disabled="permission.xjsq.applyDepartmentId!=='w'"
                  >
                    <Option
                      v-for="item in department"
                      :value="item.id"
                      :key="item.id"
                    >{{ item.name }}</Option>
                  </Select>
                </Form-item>
                <Form-item prop="applyDepartmentName" v-if="permission.xjsq.applyDepartmentId!=='w'">
                  <Input type="text" v-model="formdata.applyDepartmentName" disabled />
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 报价截止日 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.Deadline')}}</span>
              </th>
              <td>
                <Form-item prop="quoteDeadline">
                  <ab-date
                    :disabled="permission.xjsq.quoteDeadline!=='w'"
                    style="width:100%;"
                    v-model="formdata.quoteDeadline"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
              <!-- 案件名 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.caseName')}}</span>
              </th>
              <td colspan="3">
                <Form-item prop="caseName">
                  <Input type="text"
                  :disabled="permission.xjsq.caseName!=='w'"
                   v-model="formdata.caseName"  />
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 背景目的 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.Purpose')}}</span>
              </th>
              <td colspan="5">
                <Form-item prop="objective">
                  <Input
                    type="textarea"
                    autosize
                    v-model="formdata.objective"
                    :disabled="permission.xjsq.objective!=='w'"
                    :maxlength="2000"
                  />
                </Form-item>
              </td>
            </tr>
            <tr v-if="permission.xjsq.inform!=='n'">
              <!-- 仅人事可见 -->
              <th class="requiredIitm">
              <span>{{$t('label.Inquiry.inform')}}</span>
              </th>
              <td colspan="5" style="text-align:left;">
                <Form-item prop="inform">
                  <RadioGroup v-model="formdata.inform">
                      <Radio
                        :disabled="permission.xjsq.inform!=='w'"
                        label="1"
                      >{{$t('LABEL-011')}}</Radio>
                      <Radio
                        :disabled="permission.xjsq.inform!=='w'"
                        label="0"
                      >{{$t('LABEL-010')}}</Radio>
                    </RadioGroup>
                </Form-item>
              </td>
            </tr>

            <tr v-if="permission.xjsq.inform!=='n'">
              <!-- 仅总务可见 -->
              <th class="requiredIitm">
              <span>{{$t('label.Inquiry.limit')}}</span>
              </th>
              <td colspan="5" style="text-align:left;">
                <Form-item prop="limit">
                  <RadioGroup v-model="formdata.limit">
                      <Radio
                        :disabled="permission.xjsq.limit!=='w'"
                        label="1"
                      >{{$t('LABEL-011')}}</Radio>
                      <Radio
                        :disabled="permission.xjsq.limit!=='w'"
                        label="0"
                      >{{$t('LABEL-010')}}</Radio>
                    </RadioGroup>
                </Form-item>
              </td>
            </tr>

          </tbody>
        </table>
        <!-- 其他事项 -->
        <div>
          <div
            class="table_box"
            @mouseover="pmdisplayover"
            @mouseout="pmdisplayout"
          >
            <div class="itemTitle">
              <Icon type="ios-information-circle" class="icon" />
              <span
                style="cursor: pointer;font-size:13px;"
              >{{$t('label.Inquiry.PurchaseTips')}}</span>
              <Icon type="ios-help-circle-outline" class="icon" style="margin-left:10px;color:#000;"/>
            </div>
            <table class="i-iview-table form-table" style="margin-top:10px;" v-show="pmdisplayflg">
              <thead>
                <tr class="firstRow">
                  <th style="width:5%;">
                    <span style="font-size: 14px;">{{'NO.'}}</span>
                  </th>
                  <th style="width:30%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.Physical.Item')}}</span>
                  </th>
                  <th style="width:15%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.PurchasingDepartment')}}</span>
                  </th>
                  <th style="width:30%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.Consulting')}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val,index) in contactList" :key="index" style="height:42px;">
                  <td style="">{{index+1}}</td>
                  <td style="text-align:left;" v-html="val.name"></td>
                  <td style="text-align:left;" v-html="val.content"></td>
                  <td style="text-align:left;" v-html="val.contactNumber"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Form>

      <!-- 实物购入 -->
      <Card style="margin-top:15px;" :class="{'cardnonepadding':formDynamic.items.length===0}">
        <div slot="title" class="title_a_box">
          <span class="title">{{$t('label.Inquiry.PhysicalA')}}</span>
          <Icon
            type="md-add-circle"
            @click="handleAdd(0)"
            class="add"
            v-if="permission.xjsq.objective==='w'"
          />
        </div>
        <Form ref="formDynamic" :rules="rules" :model="formDynamic">
          <!-- 实物购入明细部分 -->
          <div
            v-for="(item, index) in formDynamic.items"
            :key="index"
            :class="{'content':index !== formDynamic.items.length-1}"
          >
            <Button
              type="error"
              @click="handleRemove(index,0)"
              style="margin-bottom:15px;"
              v-if="permission.xjsq.objective==='w'"
            >
              <Icon type="ios-alert-outline" style="margin-right:5px;" />
              {{$t('label.InquiryInvitationApply.DeleteDetail')}}
            </Button>
            <table class="form-table form-table-print">
              <tbody>
                <tr>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.Physical.Item')}}</span>
                  </th>
                  <td>
                    <Form-item :prop="'items.' + index + '.itemName'" :rules="rules.itemName">
                      <Input
                        type="text"
                        v-model="item.itemName"
                        :placeholder="$t('InquiryApply.InquiryItemNameHint')"
                        :maxlength="300"
                        :disabled="permission.xjswgr.itemName!=='w'"
                      />
                    </Form-item>
                  </td>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.Physical.Specifications')}}</span>
                  </th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.specifications'"
                      :rules="rules.specifications"
                    >
                      <Input
                        type="text"
                        v-model="item.specifications"
                        :placeholder="$t('InquiryApply.InquirySpecificationsHint')"
                        :maxlength="300"
                        :disabled="permission.xjswgr.specifications!=='w'"
                      />
                    </Form-item>
                  </td>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.Physical.Sum')}}</span>
                  </th>
                  <td>
                    <Form-item :prop="'items.' + index + '.quantity'" :rules="rules.quantity">
                      <InputNumber
                        :disabled="permission.xjswgr.quantity!=='w'"
                        :max="999999999999999"
                        class="wrongNumber"
                        :active-change="false"
                        style="width:100%;"
                        :min="0"
                        :placeholder="'2'"
                        v-model="item.quantity"
                      ></InputNumber>
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.Physical.Satisfied')}}</span>
                  </th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.deliveryDeadline'"
                      :rules="rules.deliveryDeadline"
                    >
                      <ab-date
                        :disabled="permission.xjswgr.deliveryDeadline!=='w'"
                        style="width:100%;"
                        v-model="item.deliveryDeadline"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </td>
                  <th class>
                    <span>{{$t('label.Inquiry.Physical.Attachment')}}</span>
                  </th>
                  <td>
                    <ab-upload
                      v-model="item.file"
                      abPermission="w"
                      :disabled="permission.xjswgr.deliveryDeadline!=='w'"
                      :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                    ></ab-upload>
                    <!-- <Form-item :prop="'items.' + index + '.file'">
                      <Input type="text" v-model="item.file" placeholder />
                    </Form-item>-->
                  </td>
                  <th>{{$t('label.Inquiry.Physical.Note')}}</th>
                  <td>
                  <Tooltip
                    style="width:100%;margin-top:5px;"
                    max-width="400"
                    :disabled="item.note===''"
                    :content="item.note"
                    :transfer="true"
                  >
                    <Form-item :prop="'items.' + index + '.note'">
                      <Input
                        type="text"
                        v-model="item.note"
                        placeholder
                        :maxlength="3000"
                        :disabled="permission.xjswgr.note!=='w'"
                      />
                    </Form-item>
                  </Tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 理由内容 -->
            <div class="typebox" v-if="item.swgysList && item.swgysList.length===1">
              <span class="requiredIitm">{{$t('label.Inquiry.Reason')}}:</span>
              <Form-item :prop="'items.' + index + '.incompleteQr'" :rules="rules.incompleteQr">
                <RadioGroup v-model="item.incompleteQr" class="right30">
                  <Radio
                    :disabled="permission.xjswgr.incompleteQr!=='w'"
                    label="0"
                  >{{$t('label.Inquiry.Rause')}}</Radio>
                  <Radio
                    :disabled="permission.xjswgr.incompleteQr!=='w'"
                    label="1"
                  >{{$t('label.Inquiry.HoldingCompany')}}</Radio>
                  <Radio
                    :disabled="permission.xjswgr.incompleteQr!=='w'"
                    label="2"
                  >{{$t('label.Inquiry.University')}}</Radio>
                  <!-- <Radio
                    :disabled="permission.xjswgr.incompleteQr!=='w'"
                    label="3"
                  >{{$t('label.Inquiry.CooperationProject')}}</Radio> -->
                  <Radio
                    :disabled="permission.xjswgr.incompleteQr!=='w'"
                    label="4"
                  >{{$t('label.Inquiry.Other')}}</Radio>
                </RadioGroup>
              </Form-item>
              <Form-item
                :prop="'items.' + index + '.incompleteQrt'"
                :rules="rules.incompleteQrt"
                v-if="item.incompleteQr==='4'"
              >
                <Input
                  type="text"
                  v-model="item.incompleteQrt"
                  placeholder
                  :maxlength="300"
                  :disabled="permission.xjswgr.incompleteQrt!=='w'"
                />
              </Form-item>
            </div>

            <!-- 实物购入供应商部分 -->
            <div style="margin-top:15px;">
              <div
                style="display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;"
              >
                <div v-if="permission.xjsq.objective==='w'">
                  <Button type="primary" @click="add(index,0,item)" style="margin-right:10px;">
                    <Icon type="ios-search" style="margin-right:5px;" />
                    {{$t('label.InquiryInvitationApply.AddSupplier')}}
                  </Button>
                  <!-- <Button type="primary" @click="selectSupplier(index,0,item)" style="margin-right:10px;">
                    <Icon type="ios-search" style="margin-right:5px;" />
                    搜索供应商
                  </Button>-->
                  <Button
                    type="primary"
                    @click="copy(index,0)"
                    style="margin-right:10px;"
                    v-if="formDynamic.items[0].swgysList.length>0 && index!==0 && formDynamic.items.length>0"
                  >
                    <Icon type="ios-add" style="margin-right:5px;" />
                    {{$t('label.InquiryInvitationApply.CopySupplier')}}
                  </Button>
                </div>
              </div>
              <Table
                border
                :columns="columns"
                :data="item.swgysList"
                :no-data-text="''"
                v-if="item.swgysList && item.swgysList.length>0"
              >
                <!-- 供应商名称 -->
                <template slot-scope="{ row }" slot="vendorName">
                  <Tooltip
                    style="width:100%;margin-top:5px;"
                    max-width="400"
                    :disabled="item.swgysList[row._index].vendorName===''"
                    :content="item.swgysList[row._index].vendorName"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.vendorName`"
                      :rules="rules.vendorName"
                    >
                      <Input type="text" disabled v-model="item.swgysList[row._index].vendorName">
                        <!-- <ab-cust-dialog
                          v-if="permission.xjsq.objective==='w'"
                          dialogKey="gysyl"
                          slot="append"
                          v-on:ok="pushOrgRelationList($event,0,item.swgysList[row._index],item.swgysList)"
                          :param="{}"
                        >
                          <Icon type="ios-search" />
                        </ab-cust-dialog>-->
                      </Input>
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人 -->
                <template slot-scope="{ row }" slot="client">
                  <FormItem
                    :prop="`items.${index}.swgysList.${row._index}.client`"
                    :rules="rules.client"
                  >
                    <Input
                      type="text"
                      v-model="item.swgysList[row._index].client"
                      :maxlength="300"
                      :disabled="permission.swgys.client!=='w'"
                    />
                  </FormItem>
                </template>
                <!-- 联系方式 -->
                <template slot-scope="{ row }" slot="contact">
                  <Tooltip
                    style="width:100%;margin-top:5px;"
                    max-width="400"
                    :disabled="item.swgysList[row._index].contact===''"
                    :content="item.swgysList[row._index].contact"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.contact`"
                      :rules="rules.contact"
                    >
                      <Input
                        type="text"
                        v-model="item.swgysList[row._index].contact"
                        :maxlength="300"
                        :disabled="permission.swgys.contact!=='w'"
                      />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人邮箱 -->
                <template slot-scope="{ row }" slot="email">
                  <Tooltip
                    style="width:100%;margin-top:5px;"
                    max-width="400"
                    :disabled="item.swgysList[row._index].email===''"
                    :content="item.swgysList[row._index].email"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.swgysList.${row._index}.email`"
                      :rules="rules.email"
                    >
                      <Input
                        type="text"
                        v-model="item.swgysList[row._index].email"
                        :maxlength="300"
                        :disabled="permission.swgys.email!=='w'"
                      />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 移除 -->
                <template slot-scope="{ row }" slot="remove">
                  <FormItem v-if="permission.xjsq.objective==='w'">
                    <Button
                      type="error"
                      @click="remove(index,row,0)"
                    >{{$t('label.InquiryInvitationApply.Delete')}}</Button>
                  </FormItem>
                </template>
              </Table>
            </div>
          </div>
          <!-- <Form-item>
          <Button type="primary" @click="handleSubmitb('formDynamic')">提交</Button>
          <Button type="primary" @click="handleReset('formDynamic')" style="margin-left: 8px">重置</Button>
          </Form-item>-->
        </Form>
      </Card>
      <!-- 服务 -->
      <Card style="margin-top:15px;" :class="{'cardnonepadding':formService.items.length===0}">
        <div slot="title" class="title_a_box">
          <span class="title">{{$t('label.Inquiry.Service.ServiceContent')}}</span>
          <Icon
            type="md-add-circle"
            @click="handleAdd(1)"
            class="add"
            v-if="permission.xjsq.objective==='w'"
          />
          <!-- <Button type="primary" @click="handleAdd(1)" class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
          </Button>-->
        </div>
        <Form ref="formService" :rules="rules" :model="formService">
          <!-- 服务明细部分 -->
          <div
            v-for="(item, index) in formService.items"
            :key="index"
            :class="{'content':index !== formService.items.length-1}"
          >
            <Button
              type="error"
              @click="handleRemove(index,1)"
              style="margin-bottom:15px;"
              v-if="permission.xjsq.objective==='w'"
            >
              <Icon type="ios-alert-outline" style="margin-right:5px;" />
              {{$t('label.InquiryInvitationApply.DeleteDetail')}}
            </Button>
            <table class="form-table form-table-print">
              <tbody>
                <tr>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.EntrustedContent')}}</span>
                  </th>
                  <td>
                    <Form-item :prop="'items.' + index + '.entrustment'" :rules="rules.entrustment">
                      <Input
                        type="text"
                        v-model="item.entrustment"
                        :placeholder="$t('InquiryApply.InquiryContentHint')"
                        :maxlength="300"
                        :disabled="permission.fwxx.entrustment!=='w'"
                      />
                    </Form-item>
                  </td>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.StartTime')}}</span>
                  </th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.businessHoursStart'"
                      :rules="[{ trigger: 'change',validator:(rule,value,callback)=>{changeDate(rule,value,callback,item)}}]"
                    >
                      <ab-date
                        :disabled="permission.fwxx.businessHoursStart!=='w'"
                        style="width:100%;"
                        v-model="item.businessHoursStart"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </td>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.EndTime')}}</span>
                  </th>
                  <td>
                    <Form-item
                      :prop="'items.' + index + '.businessHoursEnd'"
                      :rules="rules.businessHoursEnd"
                    >
                      <ab-date
                        :disabled="permission.fwxx.businessHoursEnd!=='w'"
                        style="width:100%;"
                        v-model="item.businessHoursEnd"
                        format="yyyy-MM-dd"
                      ></ab-date>
                    </Form-item>
                  </td>
                </tr>
                <tr>
                  <th class="requiredIitm">
                    <span>{{$t('label.Inquiry.Service.Safety')}}</span>
                  </th>
                  <td style="text-align:left;">
                    <FormItem
                      :prop="'items.' + index + '.securityType'"
                      :rules="rules.securityType"
                    >
                      <RadioGroup v-model="item.securityType">
                        <Radio
                          :disabled="permission.fwxx.securityType!=='w'"
                          label="0"
                        >{{$t('label.Inquiry.Service.WorkHigh')}}</Radio>
                        <Radio
                          :disabled="permission.fwxx.securityType!=='w'"
                          label="1"
                        >{{$t('label.Inquiry.Service.FlameCperation')}}</Radio>
                        <Radio
                          :disabled="permission.fwxx.securityType!=='w'"
                          label="2"
                        >{{$t('label.Inquiry.Service.Hydrogen')}}</Radio>
                        <Radio
                          :disabled="permission.fwxx.securityType!=='w'"
                          label="3"
                        >{{$t('label.Inquiry.Service.NO')}}</Radio>
                      </RadioGroup>
                    </FormItem>
                  </td>
                  <th class>
                    <span>{{$t('label.Inquiry.Service.Attachment')}}</span>
                  </th>
                  <td>
                    <ab-upload
                      v-model="item.file"
                      abPermission="w"
                      :disabled="permission.fwxx.file!=='w'"
                      :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"
                    ></ab-upload>
                  </td>
                  <th>{{$t('label.Inquiry.Service.Note')}}</th>
                  <td>
                    <Tooltip
                      style="width:100%;margin-top:5px;"
                      max-width="400"
                      :disabled="item.note===''"
                      :content="item.note"
                      :transfer="true"
                    >
                    <Form-item :prop="'items.' + index + '.note'">
                      <Input
                        type="text"
                        v-model="item.note"
                        :placeholder="$t('InquiryApply.InquiryNote')"
                        :maxlength="3000"
                        :disabled="permission.fwxx.note!=='w'"
                      />
                    </Form-item>
                    </Tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 理由内容 -->
            <div class="typebox" v-if="item.fwgysList && item.fwgysList.length===1">
              <span class="requiredIitm">{{$t('label.Inquiry.Reason')}} :</span>
              <Form-item :prop="'items.' + index + '.incompleteQr'" :rules="rules.incompleteQr">
                <RadioGroup v-model="item.incompleteQr" class="right30">
                  <Radio
                    :disabled="permission.fwxx.incompleteQr!=='w'"
                    label="0"
                  >{{$t('label.Inquiry.Rause')}}</Radio>
                  <Radio
                    :disabled="permission.fwxx.incompleteQr!=='w'"
                    label="1"
                  >{{$t('label.Inquiry.HoldingCompany')}}</Radio>
                  <Radio
                    :disabled="permission.fwxx.incompleteQr!=='w'"
                    label="2"
                  >{{$t('label.Inquiry.University')}}</Radio>
                  <!-- <Radio
                    :disabled="permission.fwxx.incompleteQr!=='w'"
                    label="3"
                  >{{$t('label.Inquiry.CooperationProject')}}</Radio> -->
                  <Radio
                    :disabled="permission.fwxx.incompleteQr!=='w'"
                    label="4"
                  >{{$t('label.Inquiry.Other')}}</Radio>
                </RadioGroup>
              </Form-item>
              <Form-item
                :prop="'items.' + index + '.incompleteQrt'"
                :rules="rules.incompleteQrt"
                v-if="item.incompleteQr==='4'"
              >
                <Input
                  type="text"
                  v-model="item.incompleteQrt"
                  placeholder
                  :maxlength="300"
                  :disabled="permission.fwxx.incompleteQrt!=='w'"
                />
              </Form-item>
            </div>
            <!-- 服务供应商部分 -->
            <div style="margin-top:15px;">
              <div
                style="display:flex;justify-content:space-between;margin-bottom:15px;align-items:center;"
              >
                <div v-if="permission.xjsq.objective==='w'">
                  <Button type="primary" @click="add(index,1,item)" style="margin-right:10px;">
                    <Icon type="ios-search" style="margin-right:5px;" />
                    {{$t('label.InquiryInvitationApply.AddSupplier')}}
                  </Button>
                  <Button
                    type="primary"
                    @click="copy(index,1)"
                    style="margin-right:10px;"
                    v-if="formDynamic.items.length>0 && formDynamic.items[0].swgysList.length>0"
                  >
                    <Icon type="ios-add" style="margin-right:5px;" />
                    {{$t('label.InquiryInvitationApply.CopySupplier')}}
                  </Button>
                </div>
              </div>
              <Table
                border
                :columns="columns"
                :data="item.fwgysList"
                :no-data-text="''"
                v-if="item.fwgysList && item.fwgysList.length>0"
              >
                <!-- 供应商名称 -->
                <template slot-scope="{ row }" slot="vendorName">
                  <Tooltip
                    style="width:100%;margin-top:5px;"
                    max-width="400"
                    :disabled="item.fwgysList[row._index].vendorName===''"
                    :content="item.fwgysList[row._index].vendorName"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.vendorName`"
                      :rules="rules.vendorName"
                    >
                      <Input type="text" v-model="item.fwgysList[row._index].vendorName" disabled></Input>
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人 -->
                <template slot-scope="{ row }" slot="client">
                  <FormItem
                    :prop="`items.${index}.fwgysList.${row._index}.client`"
                    :rules="rules.client"
                  >
                    <Input
                      type="text"
                      v-model="item.fwgysList[row._index].client"
                      :maxlength="300"
                      :disabled="permission.fwgys.client!=='w'"
                    />
                  </FormItem>
                </template>
                <!-- 联系方式 -->
                <template slot-scope="{ row }" slot="contact">
                  <Tooltip
                    style="width:100%;margin-top:5px;"
                    max-width="400"
                    :disabled="item.fwgysList[row._index].contact===''"
                    :content="item.fwgysList[row._index].contact"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.contact`"
                      :rules="rules.contact"
                    >
                      <Input
                        type="text"
                        v-model="item.fwgysList[row._index].contact"
                        :maxlength="300"
                        :disabled="permission.fwgys.contact!=='w'"
                      />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 委托人邮箱 -->
                <template slot-scope="{ row }" slot="email">
                  <Tooltip
                    style="width:100%;margin-top:5px;"
                    max-width="400"
                    :disabled="item.fwgysList[row._index].email===''"
                    :content="item.fwgysList[row._index].email"
                    :transfer="true"
                  >
                    <FormItem
                      :prop="`items.${index}.fwgysList.${row._index}.email`"
                      :rules="rules.email"
                    >
                      <Input
                        type="text"
                        v-model="item.fwgysList[row._index].email"
                        :maxlength="300"
                        :disabled="permission.fwgys.email!=='w'"
                      />
                    </FormItem>
                  </Tooltip>
                </template>
                <!-- 移除 -->
                <template slot-scope="{ row }" slot="remove">
                  <FormItem v-if="permission.xjsq.objective==='w'">
                    <Button
                      type="error"
                      @click="remove(index,row,1)"
                    >{{$t('label.InquiryInvitationApply.Delete')}}</Button>
                  </FormItem>
                </template>
              </Table>
            </div>
          </div>
          <!-- <Form-item>
          <Button type="primary" @click="handleSubmitb('formDynamic')">提交</Button>
          <Button type="primary" @click="handleReset('formDynamic')" style="margin-left: 8px">重置</Button>
          </Form-item>-->
        </Form>
      </Card>
    </Card>
    <Modal
      class="selcetbox_50"
      width="70%"
      v-model="modalShow"
      :title="$t('lable.Supplier.View')"
      @on-ok="getSelectList"
      @on-cancel="cancel"
    >
      <supplierPopup ref="selectbox" />
    </Modal>
  </div>
</template>
<script>
import util from "@/libs/util";
export default {
  data: function() {
    return {
      judge: false,
      keepData: {},
      modalShow: false,
      formdata: {},
      permission: {},
      contactList: [
        {
          name: $t("label.Inquiry.Camera"),
          content: $t("label.Inquiry.LegalAffairs"),
          contactNumber: $t("label.Inquiry.Liyan")
        },
        {
          name: $t("label.Inquiry.Display"),
          content: $t("label.Inquiry.SystemCourse"),
          contactNumber: $t("label.Inquiry.LiuYuanYuan")
        },
        {
          name: $t("label.Inquiry.Stationery"),
          content: $t("label.Inquiry.GeneralAffairsSection"),
          contactNumber: $t("label.Inquiry.ChenYan")
        },
        {
          name: $t("label.Inquiry.VehicleRelated"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.GuLingYan")
        },
        {
          name: $t("label.Inquiry.SpareParts"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.DingXianHua")
        },
        {
          name: $t("label.Inquiry.VehicleAccess"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.ZhangYiTing")
        }
      ],
      sqr: "",
      nodeId: null,
      detail: false,
      department: [],
      companys: [],
      strongholds: [],
      pmdisplayflg: false,
      //实物数据
      formDynamic: {
        items: []
      },
      //服务数据
      formService: {
        items: []
      },
      rules: {
        //实物明细
        itemName: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Physical.Item"),
            trigger: "change"
          }
        ],
        specifications: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Physical.Specifications"),
            trigger: "change"
          }
        ],
        note: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Physical.Note"),
            trigger: "change"
          }
        ],
        deliveryDeadline: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Physical.Satisfied"),
            trigger: "change"
          }
        ],
        quantity: [
          {
            type: "number",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  value === 0
                    ? $t("ERR.Inquiry.004")
                    : util.getmsg(this, "label.Inquiry.Physical.Sum")
                );
              } else {
                callback();
              }
            }
          }
        ],
        caseName: [
          {
            required: true,
            message: util.getmsg(this, "案件"),
            trigger: "change"
          }
        ],

        //服务明细
        entrustment: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.EntrustedContent"),
            trigger: "change"
          }
        ],
        securityType: [
          {
            required: true,

            message: util.getmsg(this, "label.Inquiry.Service.Safety"),
            trigger: "change"
          }
        ],
        note: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Physical.Note"),
            trigger: "change"
          }
        ],
        file: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.EntrustedContent"),
            trigger: "change"
          }
        ],
        businessHoursStart: [
          {
            required: true,
            type: "date",
            message: util.getmsg(this, "label.Inquiry.StartTime"),
            trigger: "change"
          }
        ],
        businessHoursEnd: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.EndTime"),
            trigger: "change"
          }
        ],
        //共用供应商校验
        incompleteQr: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Reason"),
            trigger: "change"
          }
        ],
        incompleteQrt: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Other"),
            trigger: "change"
          }
        ],
        vendorId: [
          {
            required: true,
            message: util.getmsg(
              this,
              "label.InquiryInvitationApply.SupplierDetail.SupplierID"
            ),
            trigger: "change"
          }
        ],
        vendorName: [
          {
            required: true,
            message: util.getmsg(
              this,
              "label.InquiryInvitationApply.SupplierDetail.SupplierName"
            ),
            trigger: "change"
          }
        ],
        client: [
          {
            required: true,
            message: util.getmsg(
              this,
              "label.InquiryInvitationApply.SupplierDetail.Contact"
            ),
            trigger: "change"
          }
        ],
        email: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  util.getmsg(
                    this,
                    "label.InquiryInvitationApply.SupplierDetail.Email"
                  )
                );
              } else if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(
                  $t("label.InquiryInvitationApply.SupplierDetail.Email") +
                    $t("ERR-00")
                );
              } else {
                callback();
              }
            }
          }
        ],
        contact: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  util.getmsg(
                    this,
                    "label.InquiryInvitationApply.SupplierDetail.Phone"
                  )
                );
              } else if (!/^[\d\-]+$/.test(value)) {
                callback(
                  $t("label.InquiryInvitationApply.SupplierDetail.Phone") +
                    $t("ERR-00")
                );
              } else {
                callback();
              }
            }
          }
        ]
        // contact: [
        //   { trigger: "change",validator:(rule,value,callback)=>{
        //     if(!value){
        //       callback('联系方式不可以为空')
        //     }else if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value) && !/^(0[0-9]{2,3}\-)([2-9][0-9]{4,7})+(\-[0-9]{1,4})?$/.test(value)){
        //       callback('联系方式格式不正确')
        //     }else{
        //       callback()
        //     }
        //   }}
        // ],
      },
      rule: {
        inform: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.inform"),
            trigger: "change"
          }
        ],
        applicantUserId: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Applicants"),
            trigger: "change"
          }
        ],
        applyDepartmentId: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.ApplyDepartment"),
            trigger: "change"
          }
        ],
        applyDate: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.ApplicationDate"),
            trigger: "change"
          }
        ],
        quoteDeadline: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              var data_start = this.moment(this.formdata.applyDate).format("YYYY-MM-DD").replace(/-/g, "")
              var data_end = this.moment(value).format("YYYY-MM-DD").replace(/-/g, "")
              if (!value) {
                callback(util.getmsg(this, "label.Inquiry.Deadline"));
              } else if (data_end < data_start) {
                callback($t("ERR.Inquiry.003"));
              } else {
                callback();
              }
            }
          }
        ],
        inquiryId: [
          {
            required: false,

            message: util.getmsg(this, "label.Inquiry.InquiryNo"),
            trigger: "change"
          }
        ],
        objective: [
          {
            required: true,
            message: util.getmsg(this, "label.Inquiry.Purpose"),
            trigger: "change"
          }
        ],
        caseName: [
          {
            required: true,
            message: util.getmsg(this, "件名"),
            trigger: "change"
          }
        ]
      },
      columns: [
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.SupplierName"),
          slot: "vendorName",
          align: "center",
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.SupplierName")
            );
          }
        },
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Contact"),
          slot: "client",
          align: "center",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Contact")
            );
          }
        },
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Phone"),
          slot: "contact",
          align: "center",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Phone")
            );
          }
        },
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.Email"),
          slot: "email",
          align: "center",
          width: 200,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryInvitationApply.SupplierDetail.Email")
            );
          }
        },
        {
          title: $t("label.InquiryInvitationApply.Operation"),
          slot: "remove",
          align: "center",
          width: 100
        }
      ]
    };
  },
  computed: {},
  created() {
    this.getMainDepartment();
    this.formdata = this.parent.data.xjsq;
    this.permission = this.parent.permission.xjsq;
    this.getCompany();
    this.getStronghold();
    this.abHttpUtil
      .post("/common/getFullName?account=" + this.formdata.applicantUserId)
      .then(res => {
        this.sqr = res;
      });
  },
  props: {
    parent: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    //至少有一条明细
    validate_a() {
      return (this.formDynamic.items && this.formDynamic.items.length > 0) ||
        (this.formService.items && this.formService.items.length > 0)
        ? true
        : false;
    },
    //明细中至少有一个供应商
    validate_b() {
      var flg_a = false;
      var flg_b = false;
      if (this.formDynamic.items && this.formDynamic.items.length > 0) {
        flg_a = this.formDynamic.items.every(val => val.swgysList.length > 0);
      } else {
        flg_a = true;
      }
      if (this.formService.items && this.formService.items.length > 0) {
        flg_b = this.formService.items.every(val => val.fwgysList.length > 0);
      } else {
        flg_b = true;
      }
      return flg_a && flg_b;
    }
  },
  mounted() {
    this.detail = !this.$parent.instance
      ? false
      : this.$parent.instance.status === "end" ||
        this.$parent.instance.status === "running"
      ? true
      : this.$parent.instance.status === "draft"
      ? false
      //edit fj 20211125 Start
      : false ||
        this.$parent.flowRequestParam.extendConf ||
        this.$parent.flowRequestParam.extendConf.nodeId
      ? true
      : false;
      //edit fj 20211125 End
    if (this.detail) {
      this.formDynamic.items = this.formdata.xjswgrList;
      this.formService.items = this.formdata.fwxxList;
      //重置数字参数
      if (this.formDynamic.items) {
        this.formDynamic.items.forEach(item => {
          item.swgysList.forEach(val => {
            if (!val.excludingTaxPrice) {
              this.$set(val, "excludingTaxPrice", null);
              this.$set(val, "includingTaxPrice", null);
              this.$set(val, "priceAmount", null);
              this.$set(val, "taxRate", null);
            }
          });
        });
      }
      if (this.formService.items) {
        this.formService.items.forEach(item => {
          item.fwgysList.forEach(val => {
            if (!val.excludingTaxPrice) {
              this.$set(val, "excludingTaxPrice", null);
              this.$set(val, "includingTaxPrice", null);
              this.$set(val, "priceAmount", null);
              this.$set(val, "taxRate", null);
            }
          });
        });
      }
    }
    if (this.$parent.instance && this.$parent.instance.status === "draft") {
      this.formDynamic.items = this.$parent.data.xjsq.xjswgrList;
      this.formService.items = this.$parent.data.xjsq.fwxxList;
      this.formDynamic.items.forEach(val => {
        if (!val.quantity) {
          this.$set(val, "quantity", null);
        }
        if (!val.swgysList) {
          this.$set(val, "swgysList", []);
        }
      });
      this.formService.items.forEach(val => {
        if (!val.fwgysList) {
          this.$set(val, "fwgysList", []);
        }
      });
    }
    //默认赋值
    this.formdata.inform = this.formdata.inform ? this.formdata.inform : '0'
    this.formdata.limit = this.formdata.limit ? this.formdata.limit : '0'
  },
  methods: {
    //表单提交
    // formdata
    // formDynamic
    // formService
    //保存时将数据保存到父组件
    keep() {
      this.$parent.data.xjsq = { ...this.formdata };
      this.$parent.data.xjsq.xjswgrList = this.formDynamic.items;
      this.$parent.data.xjsq.fwxxList = this.formService.items;
    },
    handleSubmit() {
      let flg = 0;
      let validateflg = false;
      this.$refs.formdata.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      this.$refs.formDynamic.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      this.$refs.formService.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      //体检自定义msg
      var list = [];
      if (!this.validate_a) {
        list.push($t("ERR.Inquiry.001"));
      }
      if (!this.validate_b) {
        list.push($t("ERR.Inquiry.002"));
      }
      if (flg === 3) {
        //验证成功
        this.errmsg(list);
        if (!this.validate_a || !this.validate_b) {
          validateflg = false;
        } else {
          this.$parent.data.xjsq = { ...this.formdata };
          this.$parent.data.xjsq.xjswgrList = this.formDynamic.items;
          this.$parent.data.xjsq.fwxxList = this.formService.items;
          console.log("提交的数据", this.$parent.data.xjsq)
          validateflg = true;
        }
      } else {
        //验证失败
        this.errmsg(list);
        validateflg = false;
      }
      return validateflg;
    },
    //表单重置
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    // 品目鼠标移入事件
    pmdisplayover(e) {
      this.pmdisplayflg = true;
    },
    // 品目鼠标移出事件
    pmdisplayout() {
      this.pmdisplayflg = false;
    },
    //明细添加
    handleAdd(type) {
      if (type === 0) {
        this.formDynamic.items.push({
          itemName: "",
          specifications: "",
          quantity: null,
          deliveryDeadline: "",
          note: "",
          file: "",
          incompleteQr: "",
          incompleteQrt: "",
          swgysList: []
        });
      } else if (type === 1) {
        this.formService.items.push({
          entrustment: "",
          businessHoursStart: "",
          businessHoursEnd: "",
          securityType: "",
          note: "",
          file: "",
          incompleteQr: "",
          incompleteQrt: "",
          fwgysList: []
        });
      }
    },
    //明细删除
    handleRemove(index, type) {
      if (type === 0) {
        this.formDynamic.items.splice(index, 1);
      } else if (type === 1) {
        this.formService.items.splice(index, 1);
      }
    },
    //删除供应商
    remove(index, row, type) {
      if (type === 0) {
        this.formDynamic.items[index].swgysList.splice(row._index, 1);
      } else if (type === 1) {
        this.formService.items[index].fwgysList.splice(row._index, 1);
      }
    },
    // 添加供应商
    add(index, type, data) {
      this.modalShow = true;
      this.keepData = {
        index: index,
        data: data,
        type: type
      };
    },
    //供应商复制
    copy(index, type) {
      if (type === 0) {
        this.formDynamic.items[index].swgysList = JSON.parse(
          JSON.stringify(this.formDynamic.items[0].swgysList)
        );
      }
      if (type === 1) {
        this.formService.items[index].fwgysList = JSON.parse(
          JSON.stringify(this.formDynamic.items[0].swgysList)
        );
      }
    },
    //model添加供应商
    pushOrgRelationList(dataArr, type, obj, list) {
      if (!dataArr) {
        return;
      }
      //判定是否有相同的供应商
      var flg = list.some(val => val.vendorId === dataArr[0].supplierid);
      if (flg) {
        this.$Message.error({ content: $t("ERR.Inquiry.009"), duration: 5 });
        return;
      }

      if (type === 0 && !flg) {
        obj.vendorId = dataArr[0].supplierid;
        obj.vendorName = dataArr[0].suppliernamecn;
        obj.client = dataArr[0].contact;
        obj.contact = dataArr[0].telno;
        obj.email = dataArr[0].mailaddress;
      }
      if (type === 1 && !flg) {
        obj.vendorId = dataArr[0].supplierid;
        obj.vendorName = dataArr[0].suppliernamecn;
        obj.client = dataArr[0].contact;
        obj.contact = dataArr[0].telno;
        obj.email = dataArr[0].mailaddress;
      }
    },
    //税率，比价金额计算事件
    numberchange(e, data, type) {
      // 0不含税金额 excludingTaxPrice
      // 1含税金额 includingTaxPrice
      // 2普票/增票 invoiceType
      // 比价金额 priceAmount
      // 税率 taxRate
      if (type === 0) {
        if (data.invoiceType === "1") {
          //增票为不含税金额
          data.priceAmount = e;
        }
        if (data.includingTaxPrice && data.includingTaxPrice !== "") {
          data.taxRate = ((data.includingTaxPrice - e) / e) * 100;
        }
      }
      if (type === 1) {
        if (data.invoiceType === "0") {
          //普票为含税金额
          data.priceAmount = e;
        }
        if (data.excludingTaxPrice && data.excludingTaxPrice !== "") {
          data.taxRate =
            ((e - data.excludingTaxPrice) / data.excludingTaxPrice) * 100;
        }
      }
      if (type === 2) {
        //e=1增票时使用不含税金额
        //e=0普票是使用含税金额
        data.priceAmount =
          e === "1"
            ? data.excludingTaxPrice
            : e === "0"
            ? data.includingTaxPrice
            : "";
      }
    },
    errmsg(custom) {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        if (custom.length > 0) {
          errMsg = errMsg.concat(custom);
        }
        errMsg.forEach(val => {
          this.$Message.error({ content: val, duration: 5 });
        });
      });
    },
    //获取当前登录人主部门
    getMainDepartment() {
      this.abHttpUtil.post("/bizGroup/getMainDepartment", {}).then(res => {
        if (this.formdata.applyDepartmentId == null) {
          this.formdata.applyDepartmentId = res;
        }
        //获取当前用户主据点
        this.abHttpUtil
          .post(
            "/bizGroup/getMainStronghold?applyDepartmentId=" +
              this.formdata.applyDepartmentId,
            {}
          )
          .then(res => {
            if (this.formdata.applyStrongholdId == null) {
              this.formdata.applyStrongholdId = res;
            }
            this.getDepartment();
          });
      });
    },
    //获取当前登陆人的所有部门
    getDepartment() {
      this.abHttpUtil
        .post(
          "/common/getStrongholdDepartment?applyStrongholdId=" +
            this.formdata.applyStrongholdId,
          {}
        )
        .then(res => {
          const data = res;
          this.department = [];
          if (this.judge) {
            this.formdata.applyDepartmentId = null;
          }
          this.judge = true;
          data.forEach(item => {
            this.department.push(item);
          });
        });
    },
    //获取现所有公司
    getCompany() {
      this.abHttpUtil.post("/bizGroup/getCompany", {}).then(res => {
        const data = res;
        data.forEach(item => {
          this.companys.push(item);
        });
        if (this.formdata.applyCompanyId == null) {
          this.formdata.applyCompanyId = this.companys[0].key;
        }
      });
    },
    //获取现所有据点
    getStronghold() {
      this.abHttpUtil.post("/bizGroup/getStronghold", {}).then(res => {
        const data = res;
        data.forEach(item => {
          this.strongholds.push(item);
        });
      });
    },
    //服务业务时间校验
    changeDate(rule, value, callback, row) {
      var start = this.moment(value)
        .format("YYYY-MM-DD")
        .replace(/-/g, "");
      var end = row.businessHoursEnd
        ? this.moment(row.businessHoursEnd)
            .format("YYYY-MM-DD")
            .replace(/-/g, "")
        : 999999999999999;
      if (!value) {
        callback(util.getmsg(this, "label.Inquiry.StartTime"));
      } else if (start > end) {
        callback($t("LABEL-012"));
      } else {
        callback();
      }
    },
    //多选供应商确定按钮
    getSelectList() {
      //没有选择直接return
      if (this.$refs.selectbox.selectedData.length === 0) {
        return;
      }
      //选中数据
      var selectList = JSON.parse(
        JSON.stringify(this.$refs.selectbox.selectedData)
      );
      //去重的数据
      var list = [];
      //插入的索引数据
      var index = this.keepData.index;
      var data = this.keepData.data;
      var type = this.keepData.type;
      //清空组件下拉数据
      this.$refs.selectbox.$refs.abGrid.handleClearSelect();
      //赋值供应商数据
      if (type === 0) {
        //数据去重赋值
        this.formDynamic.items[index].swgysList.forEach(val => {
          selectList.forEach((item, key) => {
            if (item.supplierId === val.vendorId) {
              selectList.splice(key, 1);
            }
          });
        });
        //根据去重过的数组进行赋值
        selectList.forEach(val => {
          this.formDynamic.items[index].swgysList.push({
            vendorId: val.supplierId,
            vendorName:
              val.internalFlg === "0" ? val.supplierNameCn : val.supplierNameEn,
            client: val.contact,
            priceAmount: "",
            contact: val.telNo,
            email: val.mailAddress,
            excludingTaxPrice: null,
            includingTaxPrice: null,
            priceAmount: null,
            changePriceamount: null,
            changeFile: "",
            taxRate: null,
            invoiceType: "",
            priceStartDate: "",
            priceEndDate: "",
            detailFile: "",
            note: ""
          });
        });
        if (this.formDynamic.items[index].swgysList.length > 1) {
          data.incompleteQr = "";
          data.incompleteQrt = "";
        }
      } else if (type === 1) {
        //数据去重赋值
        this.formService.items[index].fwgysList.forEach(val => {
          selectList.forEach((item, key) => {
            if (item.supplierId === val.vendorId) {
              selectList.splice(key, 1);
            }
          });
        });
        //根据去重过的数组进行赋值
        selectList.forEach(val => {
          this.formService.items[index].fwgysList.push({
            vendorId: val.supplierId,
            vendorName:
              val.internalFlg === "0" ? val.supplierNameCn : val.supplierNameEn,
            client: val.contact,
            priceAmount: "",
            contact: val.telNo,
            email: val.mailAddress,
            excludingTaxPrice: null,
            includingTaxPrice: null,
            priceAmount: null,
            taxRate: null,
            changePriceamount: null,
            changeFile: "",
            invoiceType: "",
            priceStartDate: "",
            priceEndDate: "",
            detailFile: "",
            note: ""
          });
        });
        if (this.formService.items[index].fwgysList.length > 1) {
          data.incompleteQr = "";
          data.incompleteQrt = "";
        }
      }
      //清空索引数据
      this.keepData = {};
    },
    //moadel退出
    cancel() {
      //清空组件下拉数据
      this.$refs.selectbox.$refs.abGrid.handleClearSelect();
      //清空索引数据
      this.keepData = {};
    }
  }
};
</script>
<style scoped>
.title {
  font-size: 15px;
  font-weight: bold;
  color: #2d8cf0;
}
.titlebox {
  display: flex;
  align-items: center;
}
.typebox {
  display: flex;
  align-items: center;
  margin: 15px 0px;
}
.typebox > span {
  margin-right: 5px;
}
</style>
